const LayoutType = {
  list: 'list',
  detail: 'detail',
  form: 'form',
  panel: 'panel',
} as const;

export { LayoutType };
